<!-- Floating Chat Icon -->
<div class="chat-icon" (click)="toggle()">
  <img src="assets/images/teacher.jpg" alt="Teacher" class="chat-avatar" />
  <i 
    *ngIf="!open" 
    class="bi bi-chat-dots-fill chat-toggle-icon"
  ></i>
  <i 
    *ngIf="open" 
    class="bi bi-chevron-down chat-toggle-icon"
  ></i>
</div>

<!-- Chat Window -->
<div class="chat-window" [class.open]="open">
  <div class="chat-header">
    <span>الدردشة مع المعلم</span>
    <br>
    <small class="status">المعلم سيرد عليك قريباً</small>
    <button 
      class="btn-scroll-down" 
      title="اذهب لأسفل" 
      (click)="scrollToBottom()"
    >
      <i class="bi bi-chevron-bar-down"></i>
    </button>
  </div>

  <div class="chat-body" #chatBody>
    <ul class="comments-list">
      <li 
        *ngFor="let m of messages" 
        [ngClass]="{'msg-student': m.sender==='student','msg-teacher': m.sender==='teacher'}"
      >
        <div class="msg-content">{{ m.text }}</div>
        <div class="msg-time">{{ m.timestamp | date:'h:mm a' }}</div>
      </li>
    </ul>
  </div>

  <div class="chat-footer">
    <input
      type="text"
      placeholder="اكتب رسالتك..."
      [(ngModel)]="newMessage"
      (keydown.enter)="sendMessage()"
    />
    <button (click)="sendMessage()">
      <i class="fa fa-paper-plane"></i>
    </button>
  </div>
</div>
